<template>
	<div class="home-box">
		<div class="home-box-nav"
		:class="{'home-box-nav-on': scrollTop > 100}"
		>
			<div class="home-box-nav-main">
				<div class="home-box-nav-main-logo" v-if="scrollTop <= 100">
					<img src="../assets/image/logo-lanqimu-white.png" alt="爱情全保云@澜栖木">
				</div>
				<div class="home-box-nav-main-logo" v-else>
					<img src="../assets/image/logo-lanqimu-default.png" alt="爱情全保云@澜栖木">
				</div>
                <div class="home-box-nav-main-btns">
                    <a-button :type="scrollTop > 100 ? 'primary' : 'default'" @click="gotoPath('/passport')">商家登录</a-button>
					<a-button @click="gotoPath('cashier')">收银台</a-button>
				</div>
			</div>
		</div>
        <div class="home-box-0">
           <div class="home-box-main">
			<div class="home-box-0-carousel">
               <a-carousel :autoplay="true" :dots="false" effect="fade">
                  <div><span class="home-box-0-carousel-item">锁定周边5公里同城流量</span></div>
                  <div><span class="home-box-0-carousel-item">同城配送</span></div>
                  <div><span class="home-box-0-carousel-item">到店自提</span></div>
                  <div><span class="home-box-0-carousel-item">在线预约</span></div>
				  <div><span class="home-box-0-carousel-item">精准匹配用户需求</span></div>
				  <div><span class="home-box-0-carousel-item">利用朋友圈</span></div>
               </a-carousel>
			</div>
			    
			    <div class="home-box-0-text home-box-0-text-h2">简单易用的门店小程序，在微信上做生意</div>
				<div class="home-box-0-text">扫码即用，把门店开进顾客手机里，随时随地做生意</div>
				<div class="home-box-0-text home-box-0-text-h3">突破营业时间和地理限制，破解传统门店等客模式</div>
				<div class="home-box-0-text home-box-0-text-h4">沉淀会员数据，精准营销，让每一次消费都变成回头客</div>
				<div class="home-box-0-text">实时掌握销售与库存数据，用数据驱动科学决策</div>
				<div class="home-box-0-text">一个小程序，统一品牌形象，多店管理更高效</div>
				<div class="home-box-0-btn"><a-button @click="gotoPath('/passport')" ghost>我要开店</a-button></div>
		   </div>
        </div>
		<div class="home-box-1">
			<div class="home-box-main">
				<h3>数智门店，助您轻松扩展线上业务</h3>
				<div class="home-box-items">
					<div class="home-box-item">
						<div class="home-box-item-icon">
							<a-icon type="wechat" />
						</div>
						<div class="home-box-item-text">微信生态</div>
					</div>
					<div class="home-box-item">
						<div class="home-box-item-icon">
							<a-icon type="shop" />
						</div>
						<div class="home-box-item-text">线上线下</div>
					</div>
					<div class="home-box-item">
						<div class="home-box-item-icon">
							<a-icon type="carry-out" />
						</div>
						<div class="home-box-item-text">智能预约</div>
					</div>
					<div class="home-box-item">
						<div class="home-box-item-icon">
							<a-icon type="team" />
						</div>
						<div class="home-box-item-text">会员营销</div>
					</div>
					<div class="home-box-item">
						<div class="home-box-item-icon">
							<a-icon type="pie-chart" />
						</div>
						<div class="home-box-item-text">运营决策</div>
					</div>
				</div>
			</div>            
        </div>
		<div class="home-box-2">
			<div class="home-box-main home-box-block">
				<div class="home-box-block-items">
					<div class="home-box-block-item-1">
						<div style="padding-right:60px;">
							<div class="home-box-block-item-tag"><span>微信生态</span></div>
						    <div class="home-box-block-item-title">极简体验，触手可及的“轻量化”入口</div>
						    <div class="home-box-block-item-text">
告别繁琐的APP下载与安装，门店小程序依托微信生态，用户只需“扫一扫”或“搜一搜”即可秒级进入。这种“用完即走、无需占用内存”的极简体验，极大降低了顾客的访问门槛。同时，借助微信“附近的小程序”功能，您的门店能够精准辐射周边几公里的潜在客群，将自然流量转化为线上留量。
						    </div>
						</div>
						

					</div>
					<div class="home-box-block-item-2">
                        <div class="home-box-block-item-image">
                            <img src="../assets/image/p1-1-1.png" alt="微信生态">
                        </div>
					</div>
					<div class="home-box-block-item-3">
						<div class="home-box-block-item-image">
                            <img src="../assets/image/p1-2-1.png" alt="微信生态">
                        </div>
						<div class="home-box-block-item-image">
                            <img src="../assets/image/p1-2-2.png" alt="微信生态">
                        </div>

					</div>

				</div>

</div>
        </div>
		<div class="home-box-3">
			<div class="home-box-main home-box-block">
				<div class="home-box-block-items">
					<div class="home-box-block-item-2">
						<div class="home-box-block-item-image">
                            <img src="../assets/image/p2-1-1.png" alt="线上线下">
                        </div>
					</div>
					<div class="home-box-block-item-3">
                        <div class="home-box-block-item-image">
                            <img src="../assets/image/p2-2-1.png" alt="线上线下">
                        </div>
						<div class="home-box-block-item-image">
                            <img src="../assets/image/p2-2-2.png" alt="线上线下">
                        </div>
					</div>
					<div class="home-box-block-item-1">
						<div style="padding-left:60px;">
                            <div class="home-box-block-item-tag"><span>线上线下</span></div>
						    <div class="home-box-block-item-title">全链路交易，线上线下的无缝融合</div>
						    <div class="home-box-block-item-text">
小程序不仅是展示窗口，更是强大的交易引擎。我们支持商品在线展示、购物车、在线支付（微信/支付宝）及多种履约方式（到店自提、同城配送、上门服务等）。无论是餐饮行业的扫码点餐，还是零售行业的线上秒杀、线下核销，小程序都能打通O2O闭环，让顾客随时随地享受便捷购物，同时帮助商家打破传统门店的营业时间和物理空间限制。
						    </div>
						</div>
					</div>				

				</div>

</div>
        </div>
		<div class="home-box-4">
			<div class="home-box-main home-box-block">
				<div class="home-box-block-items">
					<div class="home-box-block-item-1">
						<div style="padding-right:60px;">
						<div class="home-box-block-item-tag"><span>智能预约</span></div>
						<div class="home-box-block-item-title">智能预约与排队，重塑门店服务效率</div>
						<div class="home-box-block-item-text">
针对美业、医疗、宠物、汽修、鲜花、五金工具等强服务属性的门店，小程序提供强大的在线预约与排队取号系统。顾客可自主选择门店、技师、服务时段，提前锁定服务；商家则能根据预约情况智能排班、合理调配资源。这不仅彻底解决了现场排队拥挤的痛点，还大幅提升了门店的翻台率和服务效率，优化了顾客体验。
						</div>
</div>
					</div>
					<div class="home-box-block-item-2">
                       <div class="home-box-block-item-image">
                            <img src="../assets/image/p3-1-1.png" alt="智能预约">
                        </div>
					</div>
					<div class="home-box-block-item-3">
                        <div class="home-box-block-item-image">
                            <img src="../assets/image/p3-2-1.png" alt="智能预约">
                        </div>
						<div class="home-box-block-item-image">
                            <img src="../assets/image/p3-2-2.png" alt="智能预约">
                        </div>
						<div class="home-box-block-item-image">
                            <img src="../assets/image/p3-2-3.png" alt="智能预约">
                        </div>
					</div>

				</div>

</div>
        </div>
		<div class="home-box-5">
			<div class="home-box-main home-box-block">
				<div class="home-box-block-items">
					<div class="home-box-block-item-2">
                        <div class="home-box-block-item-image">
                            <img src="../assets/image/p4-1-1.png" alt="会员营销">
                        </div>
					</div>
					<div class="home-box-block-item-3">
						<div class="home-box-block-item-image">
                            <img src="../assets/image/p4-2-1.png" alt="会员营销">
                        </div>
						<div class="home-box-block-item-image">
                            <img src="../assets/image/p4-2-2.png" alt="会员营销">
                        </div>
						<div class="home-box-block-item-image">
                            <img src="../assets/image/p4-2-3.png" alt="会员营销">
                        </div>
						<div class="home-box-block-item-image">
                            <img src="../assets/image/p4-2-4.png" alt="会员营销">
                        </div>

					</div>
					<div class="home-box-block-item-1">
						<div style="padding-left:60px;">
						<div class="home-box-block-item-tag"><span>会员营销</span></div>
						<div class="home-box-block-item-title">数字化会员营销，构建私域流量池</div>
						<div class="home-box-block-item-text">
摆脱对第三方平台高额抽成的依赖，小程序帮助商家建立完全自主的私域流量池。通过内置的智能化会员管理系统，支持储值卡、次卡、积分兑换等丰富的卡项管理。结合拼团、砍价、分销、优惠券等裂变营销工具，商家可以轻松唤醒沉睡老客，激励老客带新客，实现低成本拓客与高复购留存。
						</div>
</div>
					</div>				

				</div>

</div>
		</div>
		<div class="home-box-6">
			<div class="home-box-main home-box-block">
				<div class="home-box-block-items">
					<div class="home-box-block-item-1">
						<div style="padding-right:60px;">
						<div class="home-box-block-item-tag"><span>运营决策</span></div>
						<div class="home-box-block-item-title">实时数据看板，驱动精细化运营决策</div>
						<div class="home-box-block-item-text">
告别凭感觉做生意，小程序后台为您提供多维度的实时数据分析报表。从销售流水、订单状态、库存预警，到会员画像、消费频次、活动转化效果，所有经营数据一目了然。商家可以据此精准洞察消费者需求，及时调整营销策略和库存结构，实现门店的科学化、精细化运营。
						</div>
</div>
					</div>
					<div class="home-box-block-item-2">
                        <div class="home-box-block-item-image">
                            <img src="../assets/image/p5-1-1.png" alt="运营决策">
                        </div>
					</div>
					<div class="home-box-block-item-3">
                        <div class="home-box-block-item-image">
                            <img src="../assets/image/p5-2-1.png" alt="运营决策">
                        </div>
						<div class="home-box-block-item-image">
                            <img src="../assets/image/p5-2-2.png" alt="运营决策">
                        </div>
					</div>

				</div>

</div>
		</div>
		<div class="home-box-7">

		</div>
		<div class="home-box-8">

		</div>
		<div class="home-box-footer">
			<div class="home-box-main">
<div>旗下商标： ❈ 爱情全保 ❈ 澜栖木 ❈ 告白花语 ❈ 码上找我 ❈ 小粉猪 ❈</div>
<div>Copyright© 杭州爱情全保云科技有限公司, All rights reserved. <a href="http://beian.miit.gov.cn/" target="_blank">浙ICP备20004866号-1</a></div>
</div>
        </div>
		
	</div>
</template>

<script>
	import countdownDjs from '../components/countdown/djs.vue';
	export default {
		components:{
			countdownDjs
		},
		data() {
			return {
				scrollTop: 0,
			}
		},
		created() {
			
		},
	
		mounted() {
			// 1. 监听页面滚动事件
            window.addEventListener('scroll', this.handleScroll);
		},
		methods:{
			handleScroll() {
              // 3. 获取滚动距离（兼容不同浏览器）
              let scrollTop = 
                  window.pageYOffset || 
                  document.documentElement.scrollTop || 
                  document.body.scrollTop;
			  console.log('handleScroll',scrollTop);
			  this.scrollTop = scrollTop;
                  /*
      // 4. 根据阈值切换背景色
      if (scrollTop > this.scrollThreshold) {
        this.containerStyle.backgroundColor = '#f0f0f0'; // 超过阈值后的背景色
      } else {
        this.containerStyle.backgroundColor = '#ffffff'; // 未超过阈值的背景色
      }
		*/
           },
			gotoPath(path){
				if(path == 'cashier'){
					window.location.href = '/cashier';
					return;
				}
				this.$router.push(path);
			},
		},
		destroyed() {
			// 2. 销毁时移除监听，防止内存泄漏
            window.removeEventListener('scroll', this.handleScroll);
		}
	}
</script>

<style>
	.home-box-0{
        width: 100%;
        height: 735px;
		background-image:url('../assets/image/bg.jpg') ;
		background-size: 100% 735px;
		background-repeat: no-repeat;
		background-position: center center;
    }
	.home-box-nav{
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100px;
		z-index: 999;
	}
	.home-box-nav-on{
		background-color: #FFFFFF;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.home-box-nav-main{
		margin: 0 auto;
		max-width: 1200px;
		height: 100px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.home-box-main{
		margin: 0 auto;
		max-width: 1200px;
		padding: 20px 0;
	}
	.home-box-block{
		height: 564px;
		border-radius: 20px;
		margin-bottom: 20px;
	}
	.home-box-footer{
		text-align: center;
	}
	.home-box-2 .home-box-main{
		    background-color: rgba(37, 99, 235, 0.08);
	}
	.home-box-3 .home-box-main{
		    background-color: rgba(0, 150, 137, 0.08);
	}
	.home-box-4 .home-box-main{
		    background-color: rgba(112, 164, 0, 0.08);
	}
	.home-box-5 .home-box-main{
		    background-color: rgba(251, 129, 5, 0.08);
	}
	.home-box-6 .home-box-main{
		    background-color: rgba(0, 174, 236, 0.08);
	}
	.home-box-0 .home-box-main{
		   padding-top: 200px;
		   text-align: center;
	}
	.home-box-0-carousel{
		padding: 20px 0;
	}
	.home-box-0-carousel-item{
		background-color: #FFFFFF;
		display: inline-block;
		padding: 5px 20px;
		border-radius: 20px;
		color: #086FD8;
	}
	.home-box-0-text{
		color: #FFFFFF;
		line-height: 40px;
	}
	.home-box-0-text-h2{
		font-size: 36px;
	}
	.home-box-0-text-h3{
		font-size: 24px;
	}
	.home-box-0-text-h4{
		font-size: 18px;
	}
	.home-box-0-btn{
		padding: 20px;
	}
	.home-box-1 .home-box-main{
		padding: 35px 0;
		text-align: center;
	}
	.home-box-1 h3{
		font-size: 36px;
	}
	.home-box-items{
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 0 auto;
		width: 600px;
		padding: 20px 0;
	}
	.home-box-item{
		cursor: pointer;
	}
	.home-box-item .home-box-item-icon{
		width: 72px;
		text-align: center;
		font-size: 48px;
		background-color: #eeeeee;
		border-radius: 10px;
	}
	.home-box-item-text{
		padding: 10px 0;
	}
	.home-box-block-items{
		padding: 30px 50px;
		display: flex;

	}
	.home-box-block-item-1{
		width: 50%;
	}
	.home-box-block-item-2{
		width: 25%;
		text-align: center;
	}
	.home-box-block-item-3{
		width: 25%;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;

	}
	.home-box-block-item-tag{
		padding: 20px 0;
	}
	.home-box-block-item-tag span{
		display: inline-block;
		padding: 5px 10px;
		border-radius: 20px;
		background-color: #eeeeee;
	}
	.home-box-block-item-title{
		font-size: 30px;
		padding: 10px 0;
		font-weight: bold;
	}
	.home-box-block-item-text{
		color: #020617;
		line-height: 24px;
		font-size: 14px;
		opacity: .6;
		padding: 10px 0;
		text-indent: 2em;
	}
	.home-box-2 .home-box-block-item-tag span{
		color: #2563EB;
        background-color: rgba(37, 99, 235, 0.15);
	}
	.home-box-2 .home-box-block-item-image img{
        box-shadow: 0 2px 10px rgba(37, 99, 235, 0.15);
	}
	.home-box-3 .home-box-block-item-tag span{
		color: #009689;
        background-color: rgba(0, 150, 137, 0.15);
	}
	.home-box-3 .home-box-block-item-image img{
        box-shadow: 0 2px 10px rgba(0, 150, 137, 0.15);
	}
	.home-box-4 .home-box-block-item-tag span{
		color: #70A400;
        background-color: rgba(112, 164, 0, 0.15);
	}
	.home-box-4 .home-box-block-item-image img{
        box-shadow: 0 2px 10px rgba(112, 164, 0, 0.15);
	}
	.home-box-5 .home-box-block-item-tag span{
		color: #FB8105;
        background-color: rgba(251, 129, 5, 0.15);
	}
	.home-box-5 .home-box-block-item-image img{
        box-shadow: 0 2px 10px rgba(251, 129, 5, 0.15);
	}
	.home-box-6 .home-box-block-item-tag span{
		color: #00AEEC;
        background-color: rgba(0, 174, 236, 0.15);
	}
	.home-box-6 .home-box-block-item-image img{
        box-shadow: 0 2px 10px rgba(0, 174, 236, 0.15);
	}
	.home-box-block-item-image img{
        border-radius: 10px;
	}
</style>
